





















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ICompany } from "../api/company.interface";
import ConfirmDialog from "@/shared/ConfirmDialog.vue";
import {
  CompanyEventBus,
  GET_COMPANIES,
  ADD_EDIT_COMPANY
} from "../api/company.event";

@Component({
  name: "companyTable",
  components: {
    ConfirmDialog
  }
})
export default class CompanyTable extends Vue {
  @Getter("company/companies") companies: ICompany[];

  $refs: {
    confirm: any;
  };

  loading: boolean = false;

  companyHeaders: any[] = [
    {
      text: "Company",
      align: "left",
      sortable: true,
      value: "name"
    },
    {
      text: "Quickbooks File",
      align: "center",
      sortable: "false",
      value: "qbDesktopPath"
    },
    {
      text: "QBWC",
      align: "center",
      sortable: "false",
      value: "id"
    },
    {
      text: "Actions",
      align: "center",
      sortable: false,
      value: "name"
    }
  ];

  mounted() {
    CompanyEventBus.$on(GET_COMPANIES, () => {
      this.getCompanies();
    });
  }

  getCompanies(): void {
    var self = this;
    self.loading = true;

    this.$store
      .dispatch("company/getAll")
      .then(() => {
        self.loading = false;
      })
      .catch(() => {
        self.loading = false;
      });
  }

  download(company: ICompany): void {
    this.$store.dispatch("company/download", company.id);
  }

  deleteCompany(company: ICompany) {
    this.$refs.confirm
      .open(
        "Are you sure?",
        // tslint:disable-next-line:max-line-length
        "Deleting this company will also delete all associated stores and data. If you wish to associate a this companies stores with another company, please update the stores before deleting this company",
        {
          color: "red"
        }
      )
      .then((confirm: boolean) => {
        if (confirm) {
          this.$store.dispatch("company/delete", company.id);
        }
      });
  }

  editCompany(company: ICompany) {
    CompanyEventBus.$emit(ADD_EDIT_COMPANY, company);
  }
}
